/**
 * Walk-in queue validation schemas.
 */
import { z } from 'zod';

export const walkInQueueReasons = [
  'walk_in',
  'pickup',
  'appointment',
  'dropoff',
  'question',
] as const;
export type WalkInQueueReason = (typeof walkInQueueReasons)[number];

export const walkInQueueStatuses = ['waiting', 'serving', 'done', 'abandoned'] as const;
export type WalkInQueueStatus = (typeof walkInQueueStatuses)[number];

export const queueDisplayNameModes = [
  'first_name',
  'first_last_init',
  'initials',
  'number',
  'full_name',
] as const;
export type QueueDisplayNameMode = (typeof queueDisplayNameModes)[number];

export const createWalkInQueueSchema = z.object({
  displayName: z.string().trim().min(1).max(100),
  customerId: z.string().uuid().nullable().optional(),
  ticketId: z.string().uuid().nullable().optional(),
  appointmentId: z.string().uuid().nullable().optional(),
  reason: z.enum(walkInQueueReasons).optional(),
  notes: z.string().max(2000).nullable().optional(),
  deviceLabel: z.string().trim().max(100).nullable().optional(),
  priority: z.coerce.number().int().min(-100).max(100).optional(),
});

export const updateWalkInQueueSchema = z.object({
  displayName: z.string().trim().min(1).max(100).optional(),
  customerId: z.string().uuid().nullable().optional(),
  ticketId: z.string().uuid().nullable().optional(),
  appointmentId: z.string().uuid().nullable().optional(),
  reason: z.enum(walkInQueueReasons).optional(),
  notes: z.string().max(2000).nullable().optional(),
  deviceLabel: z.string().trim().max(100).nullable().optional(),
  priority: z.coerce.number().int().min(-100).max(100).optional(),
});

export const reorderWalkInQueueSchema = z.object({
  direction: z.enum(['up', 'down']),
});
